import { Box, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";

import { useEffect } from "react";
import LoadingComponent from "../../app/layout/LoadingComponent";


import { useAppDispatch, useAppSelector } from "../../app/store/configureStore";
import { fetchUsersAsync } from "./usersSlice";



export default function UsersList() {
  
  const {users, status, usersLoaded} = useAppSelector(state => state.usersAdmin)

  const dispatch = useAppDispatch()
 
  useEffect(() => {
    dispatch(fetchUsersAsync())
  }, [dispatch]
  )

  if (!usersLoaded) return <LoadingComponent message="Loading users" />
 

  return (
    <>
    <Box display='flex' justifyContent='space-between'>
        <Typography sx={{ p: 2 }} variant='h4'>Users</Typography>
        
    </Box>
    <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
            <TableHead>
                <TableRow>
                    <TableCell align="center" sx={{border: 1}}>Id</TableCell>
                    <TableCell align="center" sx={{border: 1}}>UserName</TableCell>
                    <TableCell align="center" sx={{border: 1}}>Email</TableCell>
                    <TableCell align="center" sx={{border: 1}}>Full Name</TableCell>
                    <TableCell align="center" sx={{border: 1}}>Phone</TableCell>
                   
                    <TableCell align="center" sx={{border: 1}}>Address 1</TableCell>
                    <TableCell align="center" sx={{border: 1}}>Address 2</TableCell>
                    <TableCell align="center" sx={{border: 1}}>City</TableCell>
                   
                    <TableCell align="center" sx={{border: 1}}>Region</TableCell>
                    <TableCell align="center" sx={{border: 1}}>Post Code</TableCell>
                 
                    <TableCell align="center" sx={{border: 1}}>Country</TableCell>
                   
                </TableRow>
            </TableHead>
            <TableBody>
              {users &&
                [...users].sort((a, b) => {
                  if (a.userName > b.userName)
                  {return 1;}
                  if (a.userName < b.userName) {
                    return -1;
                  }
                  return 1
                }).map((user) => (
                    <TableRow
                        key={user.id}
                        sx={{ '&:last-child td, &:last-child th': { border: 1 } }}
                    >
                        <TableCell component="th" scope="row" sx={{border: 1}}>
                            {user.id}
                        </TableCell>
                        <TableCell align="center" sx={{border: 1}}>
                            
                                {user.userName}
                          
                        </TableCell>
                        <TableCell align="center" sx={{border: 1}}>{user.email}</TableCell>
                        <TableCell align="center" sx={{border: 1}}>{user.fullName}</TableCell>
                        
                        <TableCell align="center" sx={{border: 1}}>{user.phoneNumber}</TableCell>
                        <TableCell align="center" sx={{border: 1}}>{user.address1}</TableCell>
                        <TableCell align="center" sx={{border: 1}}>{user.address2}</TableCell>
                        <TableCell align="center" sx={{border: 1}}>{user.city}</TableCell>
                        <TableCell align="center" sx={{border: 1}}>{user.region}</TableCell>
                        <TableCell align="center" sx={{border: 1}}>{user.postCode}</TableCell>
                        <TableCell align="center" sx={{border: 1}}>{user.country}</TableCell>
                    </TableRow>
                ))
              }
            </TableBody>
        </Table>
    </TableContainer>
  
</>
  )
}